import apiService from '@/utils/request';

const URIs = {
  datosBancarios: '/v1/empresas/coutas'
};

export function getDatosBancarios() {
  let urlStr = URIs.datosBancarios;
  return apiService.get(urlStr);
}
